import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "toast"
  static values = { message: String, type: String }

  connect() {
    super.connect()

    // Hotwire Native re-calls connect() on `native:restore` (e.g. back from
    // notifications). Show at most once per DOM node.
    if (this.element.dataset.toastShown === "true") return
    this.element.dataset.toastShown = "true"

    const color = this.bridgeElement.bridgeAttribute("color")
    const iosImage = this.bridgeElement.bridgeAttribute("ios-image")
    const androidImage = this.bridgeElement.bridgeAttribute("android-image")

    const data = {
      message: this.messageValue || this.element.textContent?.trim() || "",
      type: this.typeValue || "notice"
    }
    if (color) data.color = color
    if (iosImage) data.iosImage = iosImage
    if (androidImage) data.androidImage = androidImage

    this.send("show", data, () => {})

    // Clear once the bridge accepted the message. If the adapter is not ready
    // yet, keep the cookie so the post-login tab recreate can show it.
    if (this.enabled) this.clearPendingNativeToastCookie()
  }

  clearPendingNativeToastCookie() {
    document.cookie = "pending_native_toast=; Max-Age=0; path=/"
  }
}
